import useIsFeatureFlagEnabled from './useIsFeatureFlagEnabled';

const useCdfEnabled = () =>
  useIsFeatureFlagEnabled('cdfEnabled');

export default useCdfEnabled;
